module.exports = __webpack_public_path__ + "img/logo_d330268.svg";